/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Container, Row} from "reactstrap";
import ActionButton, {ACTION_BUTTON_COLORS} from "./ActionButton";

class StackedBottomButtonPair extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let containerClass = "round-corners stacked-bottom-bar shadow bg-white";
        let containerStyle = {marginTop:"16px"};
        if(this.props.showDesktopVersion){
            containerClass = "stacked-bottom-bar bg-white";
            containerStyle = {marginBottom:"16px",padding:"0 0 0 0"};
        }

        let upperButton;
        if(this.props.upperButtonTextResource){
            upperButton = <Row>
                <ActionButton
                    color={ACTION_BUTTON_COLORS.RED}
                    onClick={this.props.upperButtonOnClick}
                    textResource={this.props.upperButtonTextResource}
                    textProps={this.props}
                />
            </Row>;
        }

        let lowerButton;
        if(this.props.lowerButtonTextResource){
            lowerButton = <Row style={{marginTop:"16px"}}>
                <ActionButton
                    color={ACTION_BUTTON_COLORS.GREY}
                    onClick={this.props.lowerButtonOnClick}
                    textResource={this.props.lowerButtonTextResource}
                    textProps={this.props}
                />
            </Row>;
        }
        return <Container className={containerClass} style={containerStyle}>
            {upperButton}
            {lowerButton}
        </Container>
    }
}

export default translate("translations")(StackedBottomButtonPair);